import React from 'react';
import ReactDOM from 'react-dom';
import './index.less';

class MyCascader extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            width: props.width ? props.width : 150,
            left: 0,
            right: 0,
            top: 0,
            options: props.options,
            optionsData: [],
            selectedCur: [0,0,0],
            // 已选
            selectedData:{},
            isShow: props.isShow,
            onchangecheck:props.onchangecheck,
            onCancel:props.onCancel,
        };

    }
    componentDidMount() {
        this.element = ReactDOM.findDOMNode(this);
        const { that,options } = this.props;
        if (that) {
            this.onSize(that)
        }
        if (options) {
            let arr= [];
            arr[0] = options.children,
            this.setState({
                options: options,
                optionsData: arr,
            })
        }
    }

    componentWillReceiveProps(props) {  //监听父元素 传过来值的变化 触发的函数
        const {options} = this.state;
        if (props.options.category_id !== options.category_id) {
            if (props.that) {
                this.onSize(props.that)
            }
            if (props.isShow) {
                this.setState({
                    isShow: true
                })
            }
            let arr= [];
            arr[0] = props.options.children,
            this.setState({
                options: props.options,
                optionsData: arr,
            })
        }
    }

    onSize(that) {
        const _dom = that.getBoundingClientRect()
        let bodyDom = document.body.getBoundingClientRect().top
        let _top = Math.abs(bodyDom) + parseInt(_dom.y) +  + _dom.height + 10;
        // 获取点击元素到body右边距离
        let right = document.body.clientWidth - (_dom.right)
        this.setState({
            left: parseInt(_dom.left),
            right: right,
            top: _top,
        });
        // document.addEventListener('click', (e) => {
        //     if (!this.element || this.element.contains(e.target)) return;
        //     this.handleMouseLeave()
        // });
    }

    handleMouseLeave() {
        this.timer = setTimeout(() => {
            this.setState({
                isShow: false
            });
            if(typeof this.state.onCancel == 'function'){
                if(!this.state.onCancel(false))
                    return;
            }
        }, 200);
    }
    handleSelect (menuIndex,menu,childIndex,child) {
        const {selectedCur} = this.state;
        selectedCur[menuIndex] = childIndex;
        
        this.setState({
            selectedCur,
            selectedData:child,
            
        })
        if(typeof this.state.onchangecheck == 'function'){
            if(!this.state.onchangecheck(child))
                return;
        }
    }
    handleHoverSelect (menuIndex,menu,childIndex,child) {
        clearTimeout(this.timer);
        const {optionsData} = this.state;
        const _selectData = Object.values(child.children)
        if (!_selectData.length) return
        optionsData[menuIndex+1] = _selectData;
        this.timer = setTimeout(() => {
            this.setState({
                optionsData
            })
        }, 200);
    }
    render() {
        const { width, right, top, left, optionsData } = this.state;
        let elems =
            this.state.isShow ?
                <div className='m-cascader' 
                style={right > 300 ?{ left: Number(left), top: Number(top) } : { right: Number(right), top: Number(top) }}
                onMouseLeave={()=>{ this.handleMouseLeave()}}
                >
                    <div className="cascader-menus">
                        
                        {
                            optionsData.length && optionsData.map((menus, index) => 
                                <ul className="cascader-menu" >
                                    {
                                        menus.length && menus.map((child,childIndex)=>
                                            <li 
                                            className={child.children && Object.values(child.children).length ? 'cascader-menu-item cascader-menu-item_active': 'cascader-menu-item' } 
                                            onClick={() => this.handleSelect(index,menus,childIndex,child)}
                                            onMouseEnter={()=>{this.handleHoverSelect(index,menus,childIndex,child)}}
                                            // onMouseLeave={()=>{ this.hideCategory()}}
                                            >
                                                {child.category_name}
                                            </li>
                                        ) 
                                    }
                                </ul>
                            )
                        }


                    </div>
                    {/* <div className="popper__arrow" ></div> */}
                </div>
                : null
        return (
            <span>
                {elems}
            </span>


        );
    }
}

export default MyCascader;



// WEBPACK FOOTER //
// ./src/components/cascader/index.jsx